import { createSelectors as p } from "@waitroom/state";
import d from "../../_virtual/cjs.es.js";
import { create as f } from "zustand";
import { sortHosts as u, sessionIdsKey as n } from "../../helpers/session.es.js";
import "@waitroom/utils";
import { addFullNames as m } from "../user/helpers.es.js";
import { getSessionPrimaryHost as l } from "./helpers.es.js";
const a = () => ({
  current: {
    consentToBroadcast: !1
  },
  map: {},
  modal: {}
}), i = (r) => ({
  ...r,
  primaryHost: l(r),
  hosts: u(m(r.hosts), r.primaryHostUserID)
}), y = f()(() => a()), t = p(y), T = (r) => {
  r && t.setState(
    (e) => ({
      ...e,
      map: {
        ...e.map,
        [n(r)]: i(r)
      }
    })
  );
}, M = (r, e) => {
  t.setState((o) => {
    const {
      [n({
        sessionID: r,
        sessionRecurrenceID: e
      })]: s,
      ...c
    } = o.map;
    return {
      ...o,
      map: c,
      current: o.current.id === r ? a().current : o.current
    };
  });
}, R = () => {
  t.setState(
    (r) => ({
      ...r,
      current: a().current
    })
  );
}, v = (r) => {
  if ("id" in r && r.id) {
    t.setState(
      (e) => ({
        ...e,
        current: {
          ...e.current,
          ...r
        }
      })
    );
    return;
  }
  if ("sessionID" in r) {
    t.setState(
      (e) => ({
        ...e,
        current: {
          ...e.current,
          id: r.sessionID,
          recurrenceId: r.sessionRecurrenceID
        },
        map: {
          ...e.map,
          [n(r)]: i(r)
        }
      })
    );
    return;
  }
}, x = (r) => {
  t.setState((e) => ({
    ...e,
    current: {
      ...e.current,
      latestRecurrence: r
    }
  }));
}, b = (r) => {
  t.setState((e) => {
    const o = e.map[n(r)];
    if (!o) return e;
    const s = d(o, r, {
      arrayMerge: (c, S) => c.length > 0 ? c : S
    });
    return r.hosts && (s.hosts = u(
      m(r.hosts),
      r.primaryHostUserID || o.primaryHostUserID
    )), {
      ...e,
      map: {
        ...e.map,
        [n(s)]: s
      }
    };
  });
}, k = (r) => {
  t.setState((e) => ({
    ...e,
    modal: typeof r == "number" ? { type: r } : r || {}
  }));
}, F = (r) => {
  t.setState((e) => e.modal.type === r ? {
    ...e,
    modal: {}
  } : e);
}, K = () => {
  t.setState((r) => ({
    ...r,
    current: {
      ...r.current,
      consentToBroadcast: !0
    }
  }));
}, L = () => {
  t.setState((r) => ({
    ...r,
    current: {
      ...r.current,
      consentToBroadcast: !1
    }
  }));
}, N = () => {
  t.setState(a());
};
export {
  R as clearCurrentSession,
  M as clearSession,
  F as closeSessionModal,
  K as grantConsentToBroadcast,
  N as resetSessionState,
  L as revokeConsentToBroadcast,
  v as setCurrentSession,
  x as setCurrentSessionLatestRecurrence,
  T as setSession,
  k as setSessionModal,
  b as updateSession,
  t as useSessionStore
};
